import Header from "../components/Header";
import Hero from "../components/Hero";
import About from "../components/About";
import Services from "../components/Services";
import WhyChooseUs from "../components/WhyChooseUs";
import Fleet from "../components/Fleet";
import Pricing from "../components/Pricing";
import BookTaxi from "../components/BookTaxi";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import FloatingButtons from "../components/FloatingButtons";

export default function Home() {
  return (
    <div className="bg-ink">
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <WhyChooseUs />
        <Fleet />
        <Pricing />
        <BookTaxi />
        <Contact />
      </main>
      <Footer />
      <FloatingButtons />
    </div>
  );
}
